import Form from "@/shared/form/form";
import { DynamicAttributeFieldInput } from "./dynamic-attribute-field-input";
import { Input } from "antd";
import { DynamicAttributeFieldFragment } from "gql/graphql";
import {
  DynamicAttributeFieldFormItemProvider,
  useFormItemProps,
} from "./dynamic-attribute-field-form-item-provider";
import {
  DynamicAttributeFieldInputProps,
  useInputProps,
} from "./dynamic-attribute-field-input-props";

export function DynamicAttributeField({
  meta,
}: {
  meta: DynamicAttributeFieldFragment;
}) {
  const { name, label, ...restFormItemProps } = useFormItemProps() ?? {};
  const inputProps = useInputProps();

  return (
    <>
      <Form.Item
        name={[...(Array.isArray(name) ? name : [name]), "attributeCode"]}
        hidden
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={[...(Array.isArray(name) ? name : [name]), "value"]}
        label={
          meta.__typename === "LocalizedValueDynamicAttributeDto" ? null : label
        }
        {...restFormItemProps}
      >
        <DynamicAttributeFieldInput meta={meta} {...inputProps} />
      </Form.Item>
    </>
  );
}

DynamicAttributeField.FormItem = DynamicAttributeFieldFormItemProvider;
DynamicAttributeField.ControlProps = DynamicAttributeFieldInputProps;
